import { useEffect, useRef } from 'react'
import { useProductEvent } from '@/hooks/useProductEvent'
import type { StreamResource } from '@/types/events'

/** An observation from this workspace, not a claim about publishing or OBS import. */
export function useFirstVideoEvents(
  eventId: string,
  streams: StreamResource[],
  identities: ReadonlySet<string>,
) {
  const track = useProductEvent(eventId)
  const observed = useRef(new Set<string>())
  useEffect(() => {
    for (const stream of streams) {
      if (
        !stream.attributes.participant_identity ||
        !identities.has(stream.attributes.participant_identity)
      )
        continue
      const programme = stream.attributes.source_role === 'programme'
      const name = programme ? 'first_programme_video' : 'first_camera_video'
      const key = `${eventId}:${name}`
      if (observed.current.has(key)) continue
      if (
        track(
          name,
          programme ? { programme_id: stream.id } : { camera_id: stream.id },
        )
      )
        observed.current.add(key)
    }
  }, [eventId, streams, identities, track])
}
